// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".mb-0[data-v-0ea876fa] {\n  margin-bottom: 0 !important;\n}\ninput[data-v-0ea876fa]::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n/* Firefox */\ninput[type=\"number\"][data-v-0ea876fa] {\n  -moz-appearance: textfield;\n}\n", ""]);
// Exports
module.exports = exports;
